<template>
  <div class="examination" v-loading="loading">
    <div class="content">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item :index="0">当前考试</el-menu-item>
        <el-menu-item :index="1">历史考试</el-menu-item>
      </el-menu>
      <el-card
        class="card-box"
        v-for="(i, _i) in list"
        :key="_i"
        v-show="i.showStatus == activeIndex"
      >
        <!-- 
        v-show="i.showStatus == activeIndex" -->
        <el-tooltip :content="i.title" placement="top" :disabled="i.title && i.title.length <= 20" effect="dark">
          <div class="title">{{ i.title }}</div>
        </el-tooltip>
        <div class="date">
          考试时间：{{ i.startDate }} {{ i.startTime }}~{{ i.endDate }}
          {{ i.endTime }}
        </div>
        <div class="limit">考试时长：{{ i.times }}分钟</div>
        <div class="limit" v-if="i.maxRetryTimes !== undefined && i.maxRetryTimes !== null && i.maxRetryTimes > 0 && !i.certPass">
          剩余考试机会：
          <span class="retry-times">{{ i.maxRetryTimes }}</span>
          次
        </div>
        <examinationBotton @onClick="into" :item="i"></examinationBotton>
      </el-card>
      <div class="empty" v-if="!list.length && !loading">您暂无考试</div>
    </div>
    <!-- 头像上传弹窗 -->
    <AvatarUploadDialog
      v-model="showAvatarDialog"
      @success="handleAvatarUploadSuccess"
    />
  </div>
</template>
<script>
import moment from "moment";
import examinationBotton from "./examinationBotton";
import AvatarUploadDialog from "@/components/AvatarUploadDialog.vue";
export default {
  name: "examination",
  data() {
    return {
      activeIndex: 0,
      loading: true,
      totalList: [],
      list: [],
      showAvatarDialog: false,
      pendingExamItem: null, // 待跳转的考试项
      pollingTimer: null, // 问卷状态轮询定时器
    };
  },
  methods: {
    // 检查浏览器是否支持 getUserMedia
    checkBrowserSupport() {
      // 首先检查是否支持标准的 navigator.mediaDevices.getUserMedia
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        return true; // 支持标准API
      }
      
      // 检查旧版本 API（webkit、moz、标准）
      const getUserMedia = navigator.webkitGetUserMedia || 
                         navigator.mozGetUserMedia || 
                         navigator.getUserMedia;
      if (getUserMedia) {
        return true; // 支持旧版本API
      }
      
      // 检查浏览器类型和版本
      const userAgent = navigator.userAgent || '';
      const isChrome = /Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor);
      const isFirefox = /Firefox/.test(userAgent);
      const isEdge = /Edge/.test(userAgent) || /Edg/.test(userAgent);
      const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
      
      // 如果是支持的浏览器类型，即使API暂时不可用，也认为支持（可能是权限或HTTPS问题）
      if (isChrome || isFirefox || isEdge || isSafari) {
        return true;
      }
      
      return false; // 完全不支持
    },
    
    handleSelect(key) {
      this.activeIndex = key;
      this.list = this.totalList.filter(
        (el) => el.showStatus == this.activeIndex
      );
    },
    initData() {
      this.$https.get("/api/my/exam/list").then((res) => {
        if (res.success) {
          const data = res.data.map(el =>{
            // 检查是否有待完成的问卷
            // 优先使用后端返回的 hasPendingQuestionnaire 字段
            // 备用判断：如果 pass 和 certPass 都是 null，且 status 是 graded，说明题目已完成但问卷未完成
            const hasPendingQuestionnaire = el.hasPendingQuestionnaire !== undefined 
              ? el.hasPendingQuestionnaire 
              : (el.status === 'graded' && el.pass === null && el.certPass === null);
            
            // 如果已及格（pass === true），不应该显示"继续考试"
            // 但是，如果有待完成的问卷，应该允许进入问卷页面
            let finalStatus = el.status;
            if (el.pass === true) {
              // 已及格，如果有待完成的问卷，保持 graded 状态（会显示"已考完"，但允许进入问卷）
              // 如果没有待完成的问卷，保持原状态
              finalStatus = el.status;
            } else if (!el.certPass && el.maxRetryTimes && el.maxRetryTimes > 0 && !hasPendingQuestionnaire) {
              // 未达到发证分数线，还有剩余次数，且没有待完成的问卷，显示"继续考试"
              finalStatus = 'processing';
            }
            
            return Object.assign(el, {
              status: finalStatus,
              hasPendingQuestionnaire: hasPendingQuestionnaire
            })
          });
          this.totalList = data.map((el) => {
            // 计算开始时间：startDate（时间戳） + startTime（时分）
            const startDateObj = new Date(el.startDate);
            if (el.startTime) {
              const [startHour, startMinute] = el.startTime.split(':').map(Number);
              if (!isNaN(startHour) && !isNaN(startMinute)) {
                startDateObj.setHours(startHour, startMinute, 0, 0);
              }
            }
            const startTimestamp = startDateObj.getTime();

            // 计算结束时间：endDate（时间戳） + endTime（时分）
            const endDateObj = new Date(el.endDate);
            if (el.endTime) {
              const [endHour, endMinute] = el.endTime.split(':').map(Number);
              if (!isNaN(endHour) && !isNaN(endMinute)) {
                endDateObj.setHours(endHour, endMinute, 59, 999);
              }
            }
            const endTimestamp = endDateObj.getTime();
            const now = Date.now();
            // 当前考试：只要还没结束（包括将来的考试），且状态为未开始或进行中
            // 或者：如果有待完成的问卷，即使状态是 graded，也应该显示在"当前考试"中
            // 历史考试：已经结束的考试，或状态为已完成/已评分/被退考等（且没有待完成的问卷）
            const isCurrentExam =
              now <= endTimestamp &&
              (el.status === "unstart" || el.status === "processing" || el.hasPendingQuestionnaire);

            return {
              ...el,
              startDate: moment(el.startDate).format("YYYY-MM-DD"),
              endDate: moment(el.endDate).format("YYYY-MM-DD"),
              startsTime: startTimestamp, // 使用组合后的开始时间戳
              endTsTime: endTimestamp, // 使用组合后的结束时间戳
              statusType: changeStatus(el.status, el),
              showStatus: isCurrentExam ? 0 : 1,
            };
          });
          this.list = this.totalList.filter((el) => el.showStatus == 0);
        }
        this.loading = false;
        function changeStatus(type, item) {
          // 如果有待完成的问卷，显示"去填写问卷"
          if (item.hasPendingQuestionnaire) {
            return "去填写问卷";
          }
          
          let list = {
            unstart: "开始考试",
            processing: "继续考试",
            done: "已考完",
            graded: "已考完",
            terminated: "被退考",
          };
          return list[type] || "开始考试";
        }
      });
    },
    async into(item) {
      // if (item.status == "unstart") {
      //   this.$message.error("考试未开始");
      //   return;
      // }
      
      // ✅ 优化：先检查是否有待完成的问卷（优先级高于剩余次数检查）
      if (item.hasPendingQuestionnaire) {
        // 如果有待完成的问卷，进入前重新检查状态，确保数据一致性
        try {
          const res = await this.$https.get("/api/my/exam/list");
          if (res.success) {
            const updatedItem = res.data.find(el => el.examinationId === item.examinationId);
            if (updatedItem && !updatedItem.hasPendingQuestionnaire) {
              // 问卷已完成，刷新列表并提示
              this.$message.info("问卷已完成，无法再次进入问卷页面");
              this.initData();
              return;
            }
          }
        } catch (error) {
          console.error('检查问卷状态失败:', error);
          // 如果检查失败，继续原有流程（允许进入，后端会验证）
        }
        
        // 如果有待完成的问卷，允许进入（后端会处理问卷逻辑）
        // ✅ 修复：移除不必要的 initData() 调用，进入考试页面不需要刷新列表
        let url = "/examinationDetails?";
        Object.keys(item).map((el) => {
          url += "&" + el + "=" + item[el];
        });
        this.$router.push(url);
        return;
      }
      
      // 如果没有待完成的问卷，再检查剩余考试次数
      if (item.maxRetryTimes !== undefined && item.maxRetryTimes <= 0) {
        // ✅ 优化：区分不同场景，提供更明确的提示信息
        let message = "考试次数已用完";
        if (item.status === 'graded') {
          if (item.questionnaireFinished) {
            message = "问卷已完成，考试次数已用完，无法再次考试";
          } else {
            // 理论上不会进入这里（因为上面已经检查了 hasPendingQuestionnaire）
            message = "考试次数已用完";
          }
        }
        this.$message.info(message);
        return;
      }
      
      // 检查是否已通过证书
      if (item.certPass) {
        this.$message.error("您已通过考试并获得证书");
        return;
      }
      // 检查是否已通过考试（pass === true）
      if (item.pass === true) {
        this.$message.error("您已通过考试");
        return;
      }
      if (item.status != "done" && item.status != "graded" && !item.unread) {
        const startDate = item.startsTime;
        const endDate = item.endTsTime;
        const timestamp = new Date().getTime();
        if (timestamp >= startDate && timestamp <= endDate) {
          // 如果考试需要摄像头监控，检查浏览器兼容性
          if (item.needCam) {
            const isSupported = this.checkBrowserSupport();
            if (!isSupported) {
              this.$confirm(
                `<div style="text-align: left; line-height: 2;">
                  <p><strong>您的浏览器不支持摄像头功能！</strong></p>
                  <p style="color: #ff4d4f; margin: 15px 0;">本场考试需要视频监控，请使用以下浏览器之一：</p>
                  <ul style="font-size: 15px;">
                    <li><strong>Chrome 浏览器</strong>（推荐，版本 53 或更高）</li>
                    <li><strong>Firefox 火狐浏览器</strong>（版本 36 或更高）</li>
                    <li><strong>Edge 浏览器</strong>（版本 79 或更高）</li>
                  </ul>
                  <p style="margin-top: 15px; padding: 10px; background-color: #fff3cd; border-left: 4px solid #ffc107;">
                    <strong>⚠️ 重要提示：</strong><br/>
                    • 请勿使用 <strong style="color: #d9534f;">IE浏览器</strong>（已不支持）<br/>
                    • 建议使用最新版本的 Chrome 浏览器
                  </p>
                  <p style="margin-top: 10px;">下载 Chrome 浏览器：<a href="https://www.google.cn/chrome/" target="_blank" style="color: #1890ff;">https://www.google.cn/chrome/</a></p>
                </div>`,
                "浏览器不兼容",
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "我知道了",
                  showCancelButton: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                }
              );
              return;
            }
          }
          
          // 检查证书是否需要用户头像
          const needAvatar =
            item.certificateDetails?.field?.avatar ||
            item.candidaterProfile?.avatar;
          
          if (needAvatar) {
            // 检查用户是否已上传头像
            try {
              const res = await this.$https.get("/api/my/home/getInfo");
              if (res.success && res.data) {
                const userAvatar = res.data.avatar;
                if (!userAvatar) {
                  // 用户没有头像，显示上传弹窗
                  this.pendingExamItem = item;
                  this.showAvatarDialog = true;
                  return;
                }
              }
            } catch (error) {
              console.error("获取用户信息失败:", error);
              this.$message.error("获取用户信息失败，请稍后重试");
              return;
            }
          }
          
          // 通过校验，跳转考试
          this.initData();
          let url = "/examinationDetails?";
          Object.keys(item).map((el) => {
            url += "&" + el + "=" + item[el];
          });
          this.$router.push(url);
        } else {
          if (timestamp < startDate) {
            this.$message.error("考试未开始");
          } else if (timestamp > endDate) {
            this.$message.error("考试已结束");
          }
        }
        // this.$router.push({
        //   path: "/examinationDetails",
        //   query: {
        //     id: item.examinationId,
        //     status: item.needCam ? 0 : 1
        //   },
        // });
      } else {
        // 如果状态是 done 或 graded，但有待完成的问卷，允许进入
        if (item.hasPendingQuestionnaire) {
          this.initData();
          let url = "/examinationDetails?";
          Object.keys(item).map((el) => {
            url += "&" + el + "=" + item[el];
          });
          this.$router.push(url);
          return;
        }
        
        if (item.unread) {
          this.$message.error("请学习完课程");
        } else {
          this.$message.error("进入考试失败:" + item.status);
        }
      }
    },
    // 头像上传成功后的回调
    handleAvatarUploadSuccess() {
      // 重新尝试跳转考试
      if (this.pendingExamItem) {
        const item = this.pendingExamItem;
        this.pendingExamItem = null;
        // 延迟一下，确保头像已保存
        setTimeout(() => {
          this.initData();
          let url = "/examinationDetails?";
          Object.keys(item).map((el) => {
            url += "&" + el + "=" + item[el];
          });
          this.$router.push(url);
        }, 500);
      }
    },
    
    handleVisibilityChange() {
      if (!document.hidden) {
        this.initData();
      }
    },
    
    // ✅ 优化：启动问卷状态轮询（定期检查是否有待完成的问卷）
    startQuestionnaireStatusPolling() {
      // 清除已存在的定时器
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
      }
      
      // 每30秒检查一次问卷状态
      this.pollingTimer = setInterval(() => {
        // ✅ 优化：页面不可见时暂停轮询，节省资源
        if (document.hidden || document.visibilityState === 'hidden') {
          return;
        }
        
        // 检查是否有待完成的问卷
        const hasPending = this.totalList.some(item => item.hasPendingQuestionnaire);
        if (hasPending) {
          // 如果有待完成的问卷，刷新列表以获取最新状态
          this.initData();
        }
      }, 30000); // 30秒
    },
    
    // 停止问卷状态轮询
    stopQuestionnaireStatusPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
  },
  components: {
    examinationBotton,
    AvatarUploadDialog,
  },
  mounted() {
    this.initData();

    this.$storage.setStorage([
      {
        key: "examination",
        value: [],
      },
    ]);
    
    // 页面重新可见时刷新列表（用户切换回标签页/窗口后状态即时更新）
    window.addEventListener('visibilitychange', this.handleVisibilityChange);
    
    // ✅ 优化：启动问卷状态轮询
    this.startQuestionnaireStatusPolling();
  },
  
  beforeUnmount() {
    window.removeEventListener('visibilitychange', this.handleVisibilityChange);
    
    // ✅ 优化：停止问卷状态轮询
    this.stopQuestionnaireStatusPolling();
  },
};
</script>
<style lang="less">
.examination {
  position: relative;
  text-align: center;
  padding: 2% 0;
  height: 100%;
  .content {
    display: inline-block;
    width: 90%;
    height: 100%;
    text-align: left;
    .card-box {
      width: 31.33%;
      margin: 1%;
      text-align: left;
      border-radius: 5px;
      display: inline-block;
      padding: 20px;
      cursor: pointer;
      line-height: 2;
      color: #677897;
      .title {
        font-weight: bold;
        font-size: 16px;
        height: 64px;
        line-height: 32px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-all;
      }
      .start {
        float: right;
        padding: 0 20px;
        line-height: 30px;
        margin-bottom: 5px;
      }
      .no-start {
        color: #fff;
        background: #bec1c5;
      }
      .retry-times {
        color: #ff4d4f;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
}
</style>
